import { useTranslation } from 'react-i18next';

const Hero = () => {

    const { t } = useTranslation();

    return (
        <div className="cc-header-img">
            <div className="c-header-img">
                <img className="o-loader" hidden="" />
                <img alt="" className="" src="https://pro-static.h10hotels.com/gallery/Cabecera_Reuniones_y_Eventos.jpg" />
                <h1>H10 Hotels para tus eventos y reuniones</h1>
            </div>
        </div>
    );
}
export default Hero;
